import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn_primary = _resolveComponent("v-btn-primary")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_combobox = _resolveComponent("v-combobox")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_RuleTable = _resolveComponent("RuleTable")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    fluid: "",
    class: "pb-0"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, {
        "no-gutters": "",
        cols: "12",
        class: "pb-2"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { cols: "2" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn_primary, {
                block: "",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.editPartitionTag())),
                "data-cy": "PartitionTags-add"
              }, {
                default: _withCtx(() => _cache[8] || (_cache[8] = [
                  _createTextVNode(" Ajouter ")
                ])),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, { class: "pl-2" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_text_field, {
                modelValue: _ctx.search,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.search) = $event)),
                "append-inner-icon": "$search",
                label: "Recherche",
                outlined: "",
                "hide-details": "",
                clearable: "",
                "onClick:clear": _cache[2] || (_cache[2] = ($event: any) => (_ctx.search = '')),
                density: "compact"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "2",
            class: "pl-2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_combobox, {
                modelValue: _ctx.filterCompany,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filterCompany) = $event)),
                items: _ctx.allAvailableCompanies,
                label: "Société",
                "item-title": "key",
                "item-value": "value",
                dense: "",
                outlined: "",
                "hide-details": ""
              }, null, 8, ["modelValue", "items"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_RuleTable, {
        rule: 'partitionTag',
        items: _ctx.sortedPartitionTags,
        hideDuplication: true,
        accountingCompanyId: _ctx.companyId,
        hideIntersection: true,
        maxHeight: _ctx.maxHeightRT,
        onToRoute: _cache[4] || (_cache[4] = ($event: any) => (_ctx.editPartitionTag($event))),
        onDelete: _cache[5] || (_cache[5] = ($event: any) => {
                _ctx.selectedPartitionTag = $event;
                _ctx.dialogDisconnectPartitionTag = true;
            })
      }, null, 8, ["items", "accountingCompanyId", "maxHeight"]),
      (_ctx.dialogDisconnectPartitionTag)
        ? (_openBlock(), _createBlock(_component_oss_dialog, {
            key: 0,
            modelValue: _ctx.dialogDisconnectPartitionTag,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.dialogDisconnectPartitionTag) = $event)),
            "max-width": !_ctx.$vuetify.display.mobile ? '650px' : undefined,
            fullscreen: _ctx.$vuetify.display.mobile,
            "hide-overlay": _ctx.$vuetify.display.mobile,
            title: "Supprimer la partition générique",
            "valid-title": "Retirer",
            onValid: _cache[7] || (_cache[7] = ($event: any) => (_ctx.deletePartitionTag(_ctx.selectedPartitionTag)))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, { class: "mx-2" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, null, {
                    default: _withCtx(() => [
                      _cache[9] || (_cache[9] = _createTextVNode(" Vous êtes sur le point de supprimer la partition générique ")),
                      _createElementVNode("b", null, _toDisplayString(_ctx.selectedPartitionTag.name), 1),
                      _cache[10] || (_cache[10] = _createTextVNode(". Confirmer la suppression ? "))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue", "max-width", "fullscreen", "hide-overlay"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}